import React from 'react'

export const Loader = () => {
    return (
        <div className="flex mt-4 justify-center m-auto items-center gap-4 border rounded-md w-36 text-white font-bold bg-gray-400">Loading...
            <div className="h-8 w-8 rounded-[50%] border-4 border-white border-dashed animate-spin"></div>
        </div>
    )
}
